<template>
  <div class="select-container">
    <select class="form-control" @change="changeGroup">
      <option
        v-for="option in Object.keys(options)"
        :key="option"
        :value="option"
      >
        {{ options[option] }}
      </option>
    </select>
    <svg
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clip-rule="evenodd"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      requried: true,
    },
  },
  methods: {
    changeGroup(e) {
      let group = e.target.value;

      this.$eventBus.$emit('groupChanged', group);
    }
  }
};
</script>

<style lang="scss" scoped>

svg {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0.7rem;
  top: 50%;
  transform: translateY(-50%);
}
.select-container {
  position: relative;
  select {
    border: 1px solid #fff;
    border-radius: 0.25rem;
    color: #fff;
    padding: 0.7rem;

    &:focus {
      border: 1px solid #fff;
      color: #fff;
    }
  }
}
</style>